/**
 * @file パスワード表示
 */
'use strict';

/**
 * @classname ShowPassword
 * @classdesc パスワード表示
 */
export default class ShowPassword {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--show-password
	 */
	constructor($e) {
		console.log('ShowPassword.constructor');
		this._$e = $e;
		$e.on('click', () => this.onClick());
		this._$input = $e.closest('.form-group__content').find('input');
	};


	/**
	 * 海外番号
	 *
	 * @memberof ShowPassword
	 * @return {undefined}
	 */
	onClick() {
		console.log('ShowPassword.onClick');
		if(this._$input.attr('type') === 'password'){
			this._$input.attr('type', 'text');
			this._$e.find('.icon--eye').removeClass('icon--eye-close').addClass('icon--eye-open');
		}else{
			this._$input.attr('type', 'password');
			this._$e.find('.icon--eye').removeClass('icon--eye-open').addClass('icon--eye-close');
		}
	};


	/**
	 * 電話番号確認
	 *
	 * @memberof ShowPassword
	 * @return {undefined}
	 */
	checkTel() {
		if(!this._checkTel) return;
		console.log('ShowPassword.checkTel');
		this._number = this._$e.val();
		if(!this._number || this._number === '' || this._$e.hasClass('is-invalid')) return;
		this._number = this._number.replace(/-/ig, '');
		if(this._number.length === 10 || this._number.length === 11){
			this.adjustTel();
		}
	};


	/**
	 * 電話番号整形
	 *
	 * @memberof ShowPassword
	 * @return {undefined}
	 */
	adjustTel() {
		console.log('ShowPassword.adjustTel');
		let code = [];
		for(let num in this._group){
			code.push(num * 1);
		}
		code.sort(($a, $b) => {
			return ($b - $a);
		});
		console.log(code);
		for(let i = 0, n = code.length; i < n; i++){
			const len = code[i];
			const area = this._number.substr(0, len);
			const city = this._group[len][area];
			// 一致する市外局番を見付けたら整形して整形後の電話番号を返す
			if(city){
				const tel = area + '-' + this._number.substr(len, city)+ (this._number.substr(len + city) !== '' ? '-' + this._number.substr(len + city) : '');
				console.log(tel);
				this._$e.val(tel);
				return;
			}
		}
	};
}
